import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const stats = [
    { icon: 'far fa-smile', number: '50 K', label: 'Donors' },
    { icon: 'fas fa-hand-holding-usd', number: '800 K', label: 'Donated' },
    { icon: 'fas fa-heartbeat', number: '150 K', label: 'Children Saved' },
    { icon: 'fas fa-hands-helping', number: '250 K', label: 'Volunteers' }
  ];

  return (
    <div className="home">
      {/* Banner Top */}
      <section className="banner-top">
        <div className="banner-overlay"></div>
        <div className="container">
          <div className="banner-content fade-in">
            <p className="banner-tagline">small help can make change.</p>
            <h1>We can't help everyone, but everyone can help someone!</h1>
            <h2>Your small contribution means a lot.</h2>
            <Link to="/donate">
              <button className="btn btn-donate">
                Donate Now <i className="fas fa-hand-holding-usd"></i>
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* About Us */}
      <section className="about-section" id="about">
        <div className="container padding">
          <div className="heading">
            <h2>About Us</h2>
            <p>What we do?</p>
          </div>
          
          <div className="about-row">
            <div className="about-text">
                <h3>Our Mission</h3>
                <p>
                  Our mission is to rescue and care for stray animals, especially dogs. We provide them with food, medical treatment, and love. Your donation helps us continue this noble work and reach more animals in need.
                </p>
              <div className="about-buttons">
                <button className="btn read-more-btn">Read More...</button>
                <Link to="/donate">
                  <button className="btn donate ml-2">Donate Now <i className="fas fa-hand-holding-usd"></i></button>
                </Link>
              </div>
            </div>
            <div className="about-image">
              <img src="/assets/b1.png" alt="Our Mission" />
            </div>
          </div>

          <div className="about-row reverse">
            <div className="about-image">
              <img src="/assets/b2.png" alt="Our Vision" />
            </div>
            <div className="about-text">
                <h3>Our Vision</h3>
                <p>
                  Our vision is to create a world where all animals are treated with respect, receiving food, medical treatment, and love.
                </p>
              <div className="about-buttons">
                <button className="btn read-more-btn">Read More...</button>
                <Link to="/donate">
                  <button className="btn donate ml-2">Donate Now <i className="fas fa-hand-holding-usd"></i></button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rescue Campaign */}
      <section className="campaign-section">
        <div className="container padding">
          <div className="campaign-grid">
            <div className="campaign-image">
              <img src="/assets/image.png" alt="Feed a stray dog" />
            </div>
            <div className="campaign-content">
              <h2>Help Feed & Care for Stray Dogs</h2>
              <p>
                Our mission is to rescue and care for stray animals, especially dogs. We provide them with food, medical treatment, and love. Your donation will help us continue this noble work — please donate to support us.
              </p>
              <p>
                Our vision is to create a world where all animals are treated with respect, receiving food, medical treatment, and love.
              </p>
              <Link to="/donate">
                <button className="btn donate">Donate Now <i className="fas fa-hand-holding-usd"></i></button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Donate */}
      <section className="why-donate">
        <div className="container padding">
          <div className="heading">
            <h2>Why Donate?</h2>
            <p>
              Your donation helps us rescue, feed, and medically treat stray animals, provide shelter and ongoing care, and run community outreach to reduce suffering and improve animal welfare.
            </p>
          </div>
          <div className="row">
            <div className="col-6">
              <p>
                Donations directly fund rescue missions, nutritious food, vaccinations and veterinary care for injured or sick animals, secure temporary shelter, and rehabilitation programs. They also support community outreach and spay/neuter drives that reduce suffering long-term. Every gift—no matter the size—helps save lives and improve animal welfare in our communities.
              </p>
              <div className="about-buttons">
                <button className="btn read-more-btn">Read More...</button>
                <Link to="/donate">
                  <button className="btn donate ml-2">Donate Now <i className="fas fa-hand-holding-usd"></i></button>
                </Link>
              </div>
            </div>
            <div className="col-6">
              <img src="/assets/b3.png" alt="Help Others" />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container padding">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <i className={stat.icon}></i>
                <h2>{stat.number}</h2>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Banner Bottom */}
      <section className="banner-bottom">
        <div className="banner-overlay"></div>
        <div className="container">
          <div className="banner-content">
            <p>small help can make change.</p>
            <h1>We can't help everyone, but everyone can help someone!</h1>
            <h2>Your small contribution means a lot.</h2>
            <div className="banner-buttons">
              <Link to="/donate">
                <button className="btn donate">Donate Now <i className="fas fa-hand-holding-usd"></i></button>
              </Link>
              <button className="btn read-more-btn ml-2">Join As Volunteer</button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact">
        <div className="container padding">
          <div className="heading">
            <h2>Contact Us</h2>
            <p>Any Query Contact Now!</p>
          </div>
          <div className="contact-row">
            <div className="contact-info">
              <div className="info-item">
                <i className="fas fa-map-marker-alt"></i>
                <p>Plot No- 1759, Kaliganj, P.o-arrah, Bidhannagar, Bardhaman, Durgapur Mc, West Bengal, India, 713212</p>
              </div>
              <div className="contact-details">
                <div className="contact-detail-item">
                  <i className="fas fa-phone-volume"></i>
                  <p>9475707905</p>
                </div>
                <div className="contact-detail-item">
                  <i className="far fa-envelope"></i>
                  <p>info@nqa1.in</p>
                </div>
              </div>
            </div>
            <div className="contact-form">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="form-group">
                  <label>Name</label>
                  <input type="text" name="name" placeholder="Enter Your Name" required />
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" name="subject" placeholder="Enter Your Subject" required />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea placeholder="Enter Your Message Here..." name="message" rows="10" required></textarea>
                </div>
                <div className="form-btn">
                  <button type="submit" className="btn read-more-btn">Submit Now</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

